/**
 * Saved Content Remapper
 * Flutter source: lib/data/models/saved_content.dart
 */

import type { SavedContentDto } from '@/data/dtos/savedContent/savedContentDto';
import type { JsonObject } from '@/data/types/json';
import type { SavedContentEntity } from '@/domain/entities/savedContent/savedContentEntity';
import type { SavedContentStorage } from '@/domain/entities/secureStorage/secureStorageEntities';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';

export class SavedContentRemapper {
  static fromJson(data: JsonObject): SavedContentDto {
    return {
      id: (data['id'] as string | undefined) || '',
      firebaseId: (data['firebaseId'] as string | undefined) || '',
      thumbnail: (data['thumbnail'] as string | undefined) || '',
      path: (data['path'] as string | undefined) || '',
      createdDate: (data['createdDate'] as number | undefined) || 0,
    };
  }

  static fromJsonList(dataList: JsonObject[]): SavedContentDto[] {
    return dataList.map(SavedContentRemapper.fromJson);
  }

  static toEntity(dto: SavedContentDto): SavedContentEntity {
    return { ...dto };
  }

  static toDto(entity: SavedContentEntity): SavedContentDto {
    return { ...entity };
  }

  static fromUserMedia(media: UserMediaEntity): SavedContentEntity {
    return {
      id: media.id,
      firebaseId: media.firebaseId ?? '',
      thumbnail: media.relativeThumbnailPath ?? '',
      path: media.relativePath,
      createdDate: Date.now(),
    };
  }

  static toStorageEntity(entity: SavedContentEntity): SavedContentStorage {
    return {
      id: entity.id,
      firebaseId: entity.firebaseId,
      thumbnail: entity.thumbnail,
      path: entity.path,
      createdDate: entity.createdDate,
    };
  }

  static toStorage(dto: SavedContentDto): SavedContentStorage {
    return {
      id: dto.id,
      firebaseId: dto.firebaseId,
      thumbnail: dto.thumbnail,
      path: dto.path,
      createdDate: dto.createdDate,
    };
  }

  static fromStorageEntity(storage: SavedContentStorage): SavedContentEntity {
    return { ...storage };
  }
}
